<script>
	import Vue from 'vue'
	import Dialog, {Toast, Alert, Confirm, ActionSheet, ActionSheetButton, Popup, Picker} from '../../../model/Dialog'
	import DatePicker from '../../../model/DatePicker'
	import {DialogTypes} from '../../../enum'
	import ToastComponent from './toast/Index.vue'
	import AlertComponent from './alert/Index.vue'
	import ConfirmComponent from './confirm/Index.vue'
	import ActionSheetComponent from './sheet/Index.vue'
	import PopupComponent from './popup/Index.vue'
	import NumberKeyBoardComponent from '../../viewable/keyboard/NumberKeyboard.vue'
	
	const baseZIndex = 5000
	
	export default {
		name: 'dialog-manager',
		
		render(c){
			return (this.dialogs.length > 0) ? c('db-row', {
				class: 'dialog-wrapper'
			}, this.dialogs.map(dialog => {
				return c('db-row', {
					props: {
						valign: 'middle',
						align: 'center'
					},
					class: ['dialog-inner-wrapper', dialog.transparent ? 'dialog-inner-transparent-wrapper' : ''],
					style: dialog.style,
					key: dialog.id
				}, [c(dialog.component, {
					props: {
						...dialog.props
					}
				})])
			})): null
		},
		
		computed: {
			dialogs(){
				return (this.$store.state.mobileStore.dialogs || []).map((dialog, idx) => {
					dialog.style = {
						zIndex: baseZIndex + (idx + 1) * 5 + 2
					}
					return dialog
				})
			},
			
			maskerStyle(){
				return {
					zIndex: baseZIndex + this.dialogs.length * 5
				}
			}
		},
		
		mounted(){
			Object.assign(Vue.prototype, {
				'$toast': this.toast,
				'$alert': this.alert,
				'$dialog': this.dialog,
				'$confirm': this.confirm,
				'$actionSheet': this.actionSheet,
				'$popup': this.popup,
				'$picker': this.picker,
				'$datePicker': this.datePicker,
				'$close': this.close,
				'$keyboard': this.keyboard
			})
		},
		
		methods: {
			async toast(props = new Toast()){
				return new Promise(res => {
					this.$store.commit('mobileStore/addDialog', new Dialog({
						component: ToastComponent,
						props
					}))
					setTimeout(() => {
						res()
					}, parseInt(400))
				})
			},
			
			async dialog(props = new Dialog()){
				this.setElementBlur()
				return new Promise(res => {
					this.$store.commit('mobileStore/addDialog', props)
					setTimeout(() => {
						res()
					}, parseInt(50))
				})
			},
			
			async keyboard(props = {}){
				return new Promise(res => {
					this.$store.commit('mobileStore/addDialog', new Dialog({
						component: PopupComponent,
						props: {
							title: '请输入',
							height: '660',
							component: NumberKeyBoardComponent,
							props
						}
					}))
					setTimeout(() => {
						res()
					}, parseInt(50))
				})
			},
			
			async alert(props = new Alert()){
				return new Promise(res => {
					this.$store.commit('mobileStore/addDialog', new Dialog({
						component: AlertComponent,
						props
					}))
					setTimeout(() => {
						res()
					}, 300)
				})
			},
			
			async confirm(props = new Confirm()){
				return new Promise(res => {
					this.$store.commit('mobileStore/addDialog', new Dialog({
						component: ConfirmComponent,
						props
					}))
					setTimeout(() => {
						res()
					}, 300)
				})
			},
			
			async actionSheet(props = new ActionSheet()){
				this.setElementBlur()
				return new Promise(res => {
					this.$store.commit('mobileStore/addDialog', new Dialog({
						component: ActionSheetComponent,
						props
					}))
					setTimeout(() => {
						res()
					}, 300)
				})
			},
			
			async popup(props = new Popup()){
				const activeElement = document.activeElement
				if(activeElement.tagName == 'INPUT'){
					activeElement.blur()
				}
				return new Promise(res => {
					this.$store.commit('mobileStore/addDialog', new Dialog({
						component: PopupComponent,
						props
					}))
					setTimeout(() => {
						res()
					}, 300)
				})
			},
			
			async picker(props = {}){
				this.setElementBlur()
				return new Promise(res => {
					this.$store.commit('mobileStore/addDialog', new Dialog({
						component: PopupComponent,
						props: props instanceof Picker ? props : new Picker(props)
					}))
					setTimeout(() => {
						res()
					}, 300)
				})
			},
			
			async datePicker(props = {}){
				this.setElementBlur()
				props = props instanceof Picker ? props : new DatePicker(props)
				props.init()
				return new Promise(res => {
					this.$store.commit('mobileStore/addDialog', new Dialog({
						component: PopupComponent,
						props
					}))
					setTimeout(() => {
						res()
					}, 300)
				})
			},
			
			async close(){
				const dialog = this.dialogs[this.dialogs.length - 1]
				return new Promise(async (res, rej) => {
					await dialog.component.close()
					res()
				})
			},
			
			setElementBlur(){
				/* const ele = document.activeElement
				if(ele && (ele.tagName === 'INPUT' || ele.tagName === 'TEXTAREA')){
				    ele.blur()
				} */
				const {activeElement} = document
				if(activeElement && ['INPUT', 'TEXTAREA'].includes(activeElement.tagName)){
					activeElement.blur()
				}
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.dialog-wrapper{
		position: fixed;
		top: 0;
		left: 0;
		z-index: 5000;
		
		.dialog-masker{
			position: absolute;
			top: 0;
			left: 0;
			background: rgba(#000, .5);
		}
		
		.dialog-inner-wrapper{
			position: absolute;
			top: 0;
			left: 0;
			background: rgba(#000, .5);
			
			&.dialog-inner-transparent-wrapper{
				background: transparent;
			}
		}
	}
</style>
